export interface AgChartThemeOverrides {}
export interface AgChartThemePalette {}
export interface AgChartThemeDefinition {}
export type AgChartTheme = string | AgChartThemeDefinition;

/**
 * Internal Use Only: Used to ensure this file is treated as a module until we can use moduleDetection flag in Ts v4.7
 */
 export const __FORCE_MODULE_DETECTION = 0;
